import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TraerDatosService } from '../services/traer-datos.service';
import { NgForm } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { recargaAlmacen } from '../models/nuevoDocumento';
import Swal from 'sweetalert2';

export interface ArticuloEnTabla {
  partida: any;
  partidaDesc: string;
  producto: any;
  productoDesc: string;
  proveedor: string;
  proveedorDesc: string;
  folio: string;
  cantidad: number;
  costoUnitario: number;
  importe: number;
  totalCompra: number;
  fechaAd: string;
  numeroConsecutivo: string;
  ejercicio: number;
}

@Component({
  selector: 'app-mis-seguimientos',
  templateUrl: './mis-seguimientos.component.html',
  styleUrls: ['./mis-seguimientos.component.css']
})
export class MisSeguimientosComponent implements OnInit {

  API_URL = environment.uri_api;

  partidas: any = [];
  productos: any = [];
  proveedores: any = [];

  articuloValido: boolean = false;

  terminoBusqueda: string = '';
  productosFiltrados: any[] = [];

  Recargastock: recargaAlmacen = {
    partida: null,
    producto: null,
    proveedor: '',
    folio: '',
    cantidad: null,
    fechaAd: null,
    importe: null,
    totalCompra: null,
    numeroConsecutivo: '',
    ejercicio: null
  };

  monedaFormateada: any = '$ 0.00';
  monedaFormateada2: any = '$ 0.00';

  // Tabla acumuladora
  tablaArticulos: ArticuloEnTabla[] = [];
  folioFijado: string = '';
  folioYaCapturado: boolean = false;

  // Campos fijos por carga
  numeroConsecutivoFijado: string = '';
  fechaCompraFijada: string = '';
  ejercicioFijado: number = 0;

  guardandoTodo: boolean = false;

  // Habilitación progresiva
  proveedorHabilitada: boolean = false;
  ejercicioHabilitada: boolean = false;
  folioHabilitada: boolean = false;
  partidaHabilitada: boolean = false;
  productoHabilitada: boolean = false;
  cantidadHabilitada: boolean = false;

  direccionSeleccionada: number | null = null;
  costo_unitario: number = 0;

  constructor(private traer: TraerDatosService, private currencyPipe: CurrencyPipe) { }

  ngOnInit(): void {
    const fecha = new Date();
    const anio = fecha.getFullYear();
    this.Recargastock.ejercicio = anio;

    this.traerPartidas();
    this.traerProveedores();
    this.actualizarHabilitados();
  }

  actualizarHabilitados(): void {
    const batchIniciado = this.folioYaCapturado;

    this.proveedorHabilitada = batchIniciado || !!this.Recargastock.fechaAd;
    this.ejercicioHabilitada = this.proveedorHabilitada && (batchIniciado || !!this.direccionSeleccionada);
    this.folioHabilitada     = this.ejercicioHabilitada && (batchIniciado || !!this.Recargastock.ejercicio);
    this.partidaHabilitada   = this.folioHabilitada     && (batchIniciado || !!this.Recargastock.folio);
    this.productoHabilitada  = this.partidaHabilitada   && !!this.Recargastock.partida;
    this.cantidadHabilitada  = this.productoHabilitada  && this.articuloValido;
  }

  AgregarATabla(form: NgForm): void {
    if (!this.Recargastock.numeroConsecutivo ||
        !this.Recargastock.fechaAd ||
        !this.direccionSeleccionada ||
        !this.Recargastock.ejercicio ||
        !this.Recargastock.folio ||
        !this.Recargastock.partida ||
        !this.Recargastock.producto ||
        !this.Recargastock.cantidad) {
      Swal.fire('Error', '¡Todos los campos son obligatorios antes de agregar!', 'warning');
      return;
    }

    const partidaObj = this.partidas.find((p: any) => p.id == this.Recargastock.partida);
    const productoObj = this.productos.find((p: any) => p.id == this.Recargastock.producto);
    const proveedorObj = this.proveedores.find((p: any) => p.id == this.direccionSeleccionada);

    const fila: ArticuloEnTabla = {
      partida: this.Recargastock.partida,
      partidaDesc: partidaObj ? `${partidaObj.clave} -- ${partidaObj.descripcion}` : '',
      producto: this.Recargastock.producto,
      productoDesc: productoObj ? productoObj.descripcion : '',
      proveedor: this.direccionSeleccionada.toString(),
      proveedorDesc: proveedorObj ? proveedorObj.razon_social : '',
      folio: this.Recargastock.folio,
      cantidad: this.Recargastock.cantidad,
      costoUnitario: this.costo_unitario,
      importe: this.Recargastock.importe,
      totalCompra: this.Recargastock.totalCompra,
      fechaAd: this.Recargastock.fechaAd || '',
      numeroConsecutivo: this.Recargastock.numeroConsecutivo,
      ejercicio: this.Recargastock.ejercicio || 0
    };

    if (!this.folioYaCapturado) {
      this.numeroConsecutivoFijado = this.Recargastock.numeroConsecutivo;
      this.fechaCompraFijada = this.Recargastock.fechaAd || '';
      this.ejercicioFijado = this.Recargastock.ejercicio || 0;
      this.folioFijado = this.Recargastock.folio;
      this.folioYaCapturado = true;
    }

    this.tablaArticulos.push(fila);

    // Reset para siguiente artículo
    this.articuloValido = false;
    this.terminoBusqueda = '';
    this.monedaFormateada = '$ 0.00';
    this.monedaFormateada2 = '$ 0.00';
    this.costo_unitario = 0;
    this.direccionSeleccionada = null;

    this.Recargastock = {
      partida: null,
      producto: null,
      proveedor: '',
      folio: this.folioFijado,
      cantidad: null,
      fechaAd: this.fechaCompraFijada,
      importe: null,
      totalCompra: null,
      numeroConsecutivo: this.numeroConsecutivoFijado,
      ejercicio: this.ejercicioFijado
    };

    form.resetForm({
      Folio: this.folioFijado,
      NumeroConsecutivo: this.numeroConsecutivoFijado,
      FechaAdqui: this.fechaCompraFijada,
      Ejercicio: this.ejercicioFijado
    });

    this.actualizarHabilitados();
  }

  EliminarFila(index: number): void {
    Swal.fire({
      title: '¿Eliminar artículo?',
      text: 'Se quitará de la lista. No se ha guardado nada todavía.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.tablaArticulos.splice(index, 1);
        if (this.tablaArticulos.length === 0) {
          this.folioFijado = '';
          this.folioYaCapturado = false;
          this.numeroConsecutivoFijado = '';
          this.fechaCompraFijada = '';
          this.ejercicioFijado = 0;
          this.Recargastock.numeroConsecutivo = '';
          this.Recargastock.fechaAd = null;
          this.Recargastock.ejercicio = null;
          this.Recargastock.folio = '';
          this.actualizarHabilitados();
        }
      }
    });
  }

  GuardarTodo(): void {
    if (this.tablaArticulos.length === 0) {
      Swal.fire('Aviso', 'No hay artículos en la lista para guardar.', 'info');
      return;
    }

    Swal.fire({
      title: '¿Guardar todo?',
      text: `Se guardarán ${this.tablaArticulos.length} artículo(s) en el stock.`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'Cancelar'
    }).then((res) => {
      if (!res.isConfirmed) return;

      this.guardandoTodo = true;

      this.traer.http
        .post(this.API_URL + `/recargarStockLote`, { articulos: this.tablaArticulos })
        .subscribe({
          next: (resp: any) => {
            this.guardandoTodo = false;
            if (resp === 'reload' || resp?.ok) {
              Swal.fire('¡Listo!', 'Todos los artículos fueron agregados al stock.', 'success');
              this.tablaArticulos = [];
              this.folioFijado = '';
              this.folioYaCapturado = false;
              this.numeroConsecutivoFijado = '';
              this.fechaCompraFijada = '';
              this.ejercicioFijado = 0;
              this.Recargastock.numeroConsecutivo = '';
              this.Recargastock.fechaAd = null;
              this.Recargastock.ejercicio = null;
              this.Recargastock.folio = '';
              this.actualizarHabilitados();
            } else {
              Swal.fire('Error', 'Contacte a soporte.', 'error');
            }
          },
          error: () => {
            this.guardandoTodo = false;
            Swal.fire('Error', 'No se pudo conectar con el servidor.', 'error');
          }
        });
    });
  }

  opcionSeleccionadaX(): void {
    this.articuloValido = false;
    this.terminoBusqueda = '';
    this.Recargastock.producto = null;
    this.productosFiltrados = [];

    this.traer.http
      .get(this.API_URL + `/traerProductos/${this.Recargastock.partida}`)
      .subscribe((res: any) => {
        this.productos = res;
        this.productosFiltrados = res;
      });
  }

  buscarYSeleccionar(): void {
    const match = this.productos.find((p: any) => p.descripcion === this.terminoBusqueda);
    if (match) {
      this.Recargastock.producto = match.id;
      if (this.direccionSeleccionada) {
        this.CapturarValor();
      }
    } else {
      this.Recargastock.producto = null;
    }
    this.actualizarHabilitados();
  }

  traerProveedores(): void {
    this.traer.http.get(this.API_URL + `/traerProveedores`).subscribe((res: any) => {
      this.proveedores = res;
    });
  }

  CapturarValor(): void {
    const idproveedor = this.direccionSeleccionada;
    const idArticulo = this.Recargastock.producto;

    if (!idproveedor || !idArticulo) return;

    this.traer.http
      .get(this.API_URL + `/traerCostoArticulo/${idproveedor}/${idArticulo}`)
      .subscribe((res: any) => {
        if (res === 'ArticuloNoEncontrado') {
          Swal.fire({ title: 'No encontrado', text: 'El artículo con el proveedor seleccionado no se encuentra en el almacén.', icon: 'warning' });
          this.costo_unitario = 0;
          this.articuloValido = false;
          this.Recargastock.importe = 0;
          this.Recargastock.totalCompra = 0;
          this.monedaFormateada = '$ 0.00';
          this.monedaFormateada2 = '$ 0.00';
          this.Recargastock.cantidad = 0;
        } else {
          this.costo_unitario = +res;
          this.articuloValido = true;
          if (this.Recargastock.cantidad) this.CalcularImporteyTotal();
        }
        this.actualizarHabilitados();
      });
  }

  CalcularImporteyTotal(): void {
    if (this.Recargastock.cantidad && this.Recargastock.cantidad <= 0) this.Recargastock.cantidad = 1;
    this.Recargastock.importe = this.costo_unitario * (this.Recargastock.cantidad || 0);
    this.monedaFormateada = this.currencyPipe.transform(this.Recargastock.importe, 'USD', '$');
    this.Recargastock.totalCompra = this.Recargastock.importe + this.Recargastock.importe * 0.16;
    this.monedaFormateada2 = this.currencyPipe.transform(this.Recargastock.totalCompra, 'USD', '$');
  }

  traerPartidas(): void {
    this.traer.http.get(this.API_URL + `/traerPartidas`).subscribe((res: any) => {
      this.partidas = res;
    });
  }

  get totalImporteTabla(): number {
    return this.tablaArticulos.reduce((acc, a) => acc + (a.importe || 0), 0);
  }

  get totalCompraTabla(): number {
    return this.tablaArticulos.reduce((acc, a) => acc + (a.totalCompra || 0), 0);
  }
}